export type FieldTextAlign = 'left' | 'center' | 'right';

export type Field = {
  name: string;
  label: string;
  type: string;
  defaultValue?: string;
  required?: boolean;
  position?: {
    x0: number;
    y0: number;
    x1: number;
    y1: number;
    page?: number;
  };
  fontsize?: number;
  textAlign?: FieldTextAlign;
  modalComponent?: string;
  options?: (string | { value: string; label: string })[];
};

export type FormJson = {
  formName: string;
  fields: Field[];
  pdfWidth?: number;
  pdfHeight?: number;
};

export type MetaFields = {
  form_description: string;
  form_ref: string;
  reference_document: string;
  numbering_prefix: string;
  assigned_to_user_id?: number | null;
};

export const FIELD_TYPES = [
  { value: 'text', label: 'Text' },
  { value: 'textarea', label: 'Textarea' },
  { value: 'select', label: 'Select' },
  { value: 'dropdown', label: 'Dropdown (inline)' },
  { value: 'radio', label: 'Radio (inline, horizontal)' },
  { value: 'date', label: 'Date' },
  { value: 'checkbox', label: 'Checkbox' },
  { value: 'signature', label: 'Signature' },
  { value: 'submitted_by', label: 'Submitted By' },
  { value: 'number', label: 'Number' },
];

export const FIELD_TEXT_ALIGN_OPTIONS: { value: FieldTextAlign; label: string }[] = [
  { value: 'left', label: 'Left' },
  { value: 'center', label: 'Center' },
  { value: 'right', label: 'Right' },
];

export function resolveFieldTextAlign(value?: string | null): FieldTextAlign {
  if (value === 'center' || value === 'right') return value;
  return 'left';
}

export const DUPLICATE_BORDER_COLOR = '#faad14';